import PermissionsHome from './PermissionsHome';

export default PermissionsHome;
